<div class="preview" [hidden]="preview.hidden">
    <div class="mask" (click)="hide()"></div>
    <div class="content">
        <img *ngIf="preview.type === 'IMAGE'" class="video" [src]="preview.src" alt="preview"/>
        <video *ngIf="preview.type === 'VIDEO'" class="video" [src]="preview.src" controls
               preload="auto" autoplay loop #videoElement
        ></video>
    </div>
</div>
